<template>
	<DialogFormDialog ref="dialog" :strings="strings" @reset="reset">
		<v-row>
			<v-col cols="12">
				<v-text-field
					v-model="values.seconds"
					type="number"
					:rules="rules"
					placeholder="Number of seconds"
					label="Fire interval (in seconds)"
				/>
			</v-col>
		</v-row>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

const initData = () => ({
	values: {
		guid: null,
		seconds: null,
	},
});

export default {
	data: initData,

	computed: {
		strings() {
			const _strings = strings.live.scenes.intervalDialog;
			return _.isNil(this.values.guid) ? _strings.new : _strings.update;
		},

		rules() {
			return [val => !!val || "Required"];
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},

		pop(handler, node) {
			if (node) {
				this.values.guid = node.guid;
				this.values.seconds = node.properties.seconds.value;
			}
			return this.$refs.dialog.pop(handler);
		},
	},
};
</script>
